// extracted by mini-css-extract-plugin
export default {"container":"pagination-buttons_container__jOHi-","pagination-btn":"pagination-buttons_pagination-btn__AjLs1","pagination-icon":"pagination-buttons_pagination-icon__QBIRO"};